<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-info">
          <div class="card-header">Program Wise Applications Status</div>
          <div class="card-body">
            <div style="height:400px" id="chartdiv"></div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
      <div class="col-md-12">
        <div class="card card-info">
          <div class="card-header">Admission Revenue</div>
          <div class="card-body">
            <div style="height:400px" id="Barchartdiv"></div>
          </div>
          <!-- /.box-body -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default ({
    data() {
      return {
        stundents: [],
        revenue: [],
      }
    },

    created: function () {
    },

    mounted: function () {
      this.pageLoad();
    },

    updated: function () {
    },

    methods: {

      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/AverageMarks')
          .then(function (pl) {
            vm.stundents = pl.data.lst22;
            endReq();
            vm.loadChart();
          })
      },
      pageLoad2: function () {
        var vm = this;
        startReq();

        axios.post('/api/AdmissionApi/getProgWiseProspectStudentsRevenueGraph')
          .then(function (pl) {
            vm.revenue = pl.data.lst;
            endReq();
            vm.loadChart();
            vm.loadBarchart();
          })
      },
      loadChart() {
        am4core.addLicense("ch-custom-attribution");
        am4core.useTheme(am4themes_animated);
        var chart = am4core.create("chartdiv", am4charts.PieChart3D);
        chart.data = this.stundents;
        var series = chart.series.push(new am4charts.PieSeries3D());
        series.dataFields.value = "MarksObtained";
        series.dataFields.category = "StudentCount";
        series.ticks.template.disabled = true;
        series.labels.template.disabled = true;
        series.innerRadius = am4core.percent(50);
        chart.legend = new am4charts.Legend();
        chart.legend.position = "right";
        chart.legend.scrollable = true;
        chart.legend.width = "10%";

      },

      
    

    }
  })
</script>

<style>
  table thead tr th {
    background-color: #605ca8;
    color: white;
  }

  blink {
    -webkit-animation: 2s linear infinite condemned_blink_effect;
  }

  @-webkit-keyframes condemned_blink_effect {

    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }

  @keyframes condemned_blink_effect {
    0% {
      visibility: hidden;
    }

    50% {
      visibility: hidden;
    }

    100% {
      visibility: visible;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/EntryTestAverageMarks.vue